import { SortDescriptor } from "@progress/kendo-data-query";
import { GridSetup } from "../models/error-center-model";
import { FIRST_PAGE } from "../../../shared/constants/shared-contants";

export const DEFAULT_SORT: SortDescriptor[] = [
    { field: 'xeroLastAttemptAtUtc', dir: 'desc' },
];

export const INITIAL_GRID_SETUP: GridSetup = {
    ...FIRST_PAGE,
    filter: {
        logic: 'and',
        filters: [],
    },
    sort: DEFAULT_SORT,
}